<template>
    <div class="distribs">
      <b-container>
        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12"><div class="H2">{{title[language]}}</div></b-col>
        </b-row>
        <b-row>
          <b-col cols="12" sm="12" md="4" lg="6" xl="6">
            <b-row>
              <b-col cols="12" sm="6" md="12" lg="6" xl="6">
                <div class="item step1">
                  <span class="count">6</span>
                  <span class="txt">{{step1[language]}}</span>
                </div>
              </b-col>
              <b-col cols="12" sm="6" md="12" lg="6" xl="6">
                <div class="item step2">
                  <span class="count">453</span>
                  <span class="txt">{{step2.text1[language]}}</span>
                  <span v-if="language == 'en'" class="txt2">{{step2.text2[language]}}</span>
                </div>
              </b-col>
              <b-col cols="12" sm="6" md="12" lg="6" xl="6">
                <div class="item step3">
                  <div class="count">128</div>
                  <div class="info">
                    <div>{{step3.text1[language]}}</div>
                    <div>{{step3.text2[language]}}</div>
                  </div>
                </div>
              </b-col>
              <b-col class="d-md-none d-lg-block" cols="12" sm="6" md="6" lg="6" xl="6">
                <div class="item step4">
                  <div class="count">12</div>
                  <div class="info">
                    <div>{{step4.text1[language]}}</div>
                    <div>{{step4.text2[language]}}</div>
                  </div>
                </div>
              </b-col>
              <b-col class="d-md-none d-lg-block" cols="12" sm="6" md="6" lg="6" xl="6">
                <div class="item step5">
                  <span class="count">10</span>
                  <span class="txt">{{step5.text1[language]}}</span>
                  <span class="txt2">{{step5.text2[language]}}</span>
                </div>
              </b-col>
              <b-col class="d-md-none d-lg-block" cols="12" sm="6" md="6" lg="6" xl="6">
                <div class="item step6">
                  <span class="count">4 000</span>
                  <span class="txt">{{step6.text1[language]}}
                    <span v-if="language == 'en'" class="square">2</span>
                  </span>
                  <span class="txt2">{{step6.text2[language]}}</span>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" sm="12" md="8" lg="6" xl="6">
            <img v-if="language == 'ru'" src="../assets/direction_ru.png">
            <img v-else src="../assets/direction_en.png">
          </b-col>
          <b-col class="d-none d-md-block d-lg-none" md="12">
            <b-row>
              <b-col md="4">
                <div class="item step4">
                  <div class="count">12</div>
                  <div class="info">
                    <div>{{step4.text1[language]}}</div>
                    <div>{{step4.text2[language]}}</div>
                  </div>
                </div>
              </b-col>
              <b-col md="4">
                <div class="item step5">
                  <span class="count">10</span>
                  <span class="txt">{{step5.text1[language]}}</span>
                  <span class="txt2">{{step5.text2[language]}}</span>
                </div>
              </b-col>
              <b-col md="4">
                <div class="item step6">
                  <span class="count">4 000</span>
                  <span class="txt">{{step6.text1[language]}}
                    <span v-if="language == 'en'" class="square">2</span>
                  </span>
                  <span class="txt2">{{step6.text2[language]}}</span>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
</template>

<script>
export default {
  name: 'AppBaner',
  props: {
    language: {
      type: String,
      default: 'ru'
    }
  },
  data() {
    return {
      title: {
        ru: 'Дистрибуция по россии',
        en: 'Developed sales network'
      },
      step1: {
        ru: 'Дистрибьюторов',
        en: 'Distributors'
      },
      step2: {
        text1:{
          ru: 'ТПC',
          en: 'POS'
        },
        text2:{
          ru: '',
          en: 'retail network'
        }
      },
      step3: {
        text1:{
          ru: 'Городов',
          en: 'cityes'
        },
        text2:{
          ru: 'oхвата',
          en: 'coverage'
        }
      },
      step4: {
        text1:{
          ru: 'Логистических',
          en: 'logistic'
        },
        text2:{
          ru: 'направлений',
          en: 'directions'
        }
      },
      step5: {
        text1:{
          ru: 'крупнейших',
          en: 'largest'
        },
        text2:{
          ru: 'online огрегаторов',
          en: 'online aggregators'
        }
      },
      step6: {
        text1:{
          ru: 'м. кв.',
          en: 'm'
        },
        text2:{
          ru: 'складских площадей',
          en: 'warehouse space'
        }
      },
    };
  }
}
</script>

<style lang="scss">
  @media (min-width: 992px) and (max-width: 1199px) {
    .distribs .item{font-size: 14px!important;line-height: 14px!important;padding-top: 25px!important;}
    .distribs .item .count{font-size: 36px!important;}
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .distribs .item{font-size: 14px!important;line-height: 14px!important;padding-top: 25px!important;}
    .distribs .item .count{font-size: 36px!important;}
  }
  @media (min-width: 576px) and (max-width: 767px) {
    .distribs .item{font-size: 16px!important;line-height: 16px!important;padding-top: 20px!important;}
    .distribs .item .count{font-size: 36px!important;}
  }
  @media (max-width: 575px) {
    .distribs .item{font-size: 20px!important;line-height: 20px!important;padding-top: 20px!important;}
    .distribs .item .count{font-size: 40px!important;}
  }
  .distribs{background: #464646;padding: 20px 0;}
  .distribs .H2{color: #fff}
  .distribs img {max-width: 100%;height: auto;}
  .distribs .item{height: 80px;padding-left: 100px; padding-top: 15px; color: #fff;font-family: 'Open Sans Condensed', sans-serif;font-size: 20px;line-height: 20px;margin-bottom: 20px;position: relative}
  .distribs .item::before{content: '';position: absolute;width: 100px;height: 80px;left: 0;top: 0; background: url("../assets/icon_distribution_sprite.png") no-repeat;}
  .distribs .item.step1::before{background-position-x: 0px;background-position-y: 0px}
  .distribs .item.step2::before{  background-position-x: -100px;background-position-y: 0px}
  .distribs .item.step3::before{background-position-x: -200px;background-position-y: 0px}
  .distribs .item.step4::before{  background-position-x: -300px;background-position-y: 0px}
  .distribs .item.step5::before{background-position-x: -400px;background-position-y: 0px}
  .distribs .item.step6::before{  background-position-x: -500px;background-position-y: 0px}
  .distribs .item .count{font-size: 44px;font-weight: bold;display: inline-block;}
  .distribs .item .info{display: inline-block;}
  .distribs .item .txt{position: relative;}
  .distribs .item .txt2{display: block;}
  .distribs .item .txt .square{font-size: 12px;position: absolute;top: 0;right: 0;}
</style>


// WEBPACK FOOTER //
// src/views/Distribution.vue